import { render, staticRenderFns } from "./Reservas.vue?vue&type=template&id=304fb734&scoped=true"
import script from "./Reservas.vue?vue&type=script&lang=js"
export * from "./Reservas.vue?vue&type=script&lang=js"
import style0 from "./Reservas.vue?vue&type=style&index=0&id=304fb734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304fb734",
  null
  
)

export default component.exports